// src/components/reportes/ReporteStaticHTML.jsx
import React from "react";
import { formattedGlobalDate } from "../../utils/formattedDates";

/* ===================== CSS ===================== */
const customStyles = `
@page { size: A4; margin: 20mm 14mm; }

@media print {
  html, body { margin: 0 !important; background: #fff !important; }
  #reporte-static-root { box-shadow: none !important; }
  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
}

/* Raíz */
#reporte-static-root{
  background:#fff; color:#000; font-family:Arial,sans-serif; font-size:12px; line-height:1.4;
  width:794px; margin:0 auto; box-sizing:border-box;
}

/* ========= CLAVES PARA QUE EL SALTO FUNCIONE ========= */
@media print {
  .no-flex-print { display:block !important; }
  .no-flex-print > .row { display:block !important; }
}

/* Marcadores */
.force-break,
.html2pdf__page-break {
  display:block;
  width:100%;
  min-height:2mm;           /* altura real para que cuente en layout */
  overflow:visible !important;
  visibility:hidden;         /* que no “pinte” */
}

/* Garantiza salto DESPUÉS del marcador */
.force-break {
  page-break-after: always;
  break-after: page;
}

/* Iniciar la siguiente sección en nueva página */
.page-start {
  page-break-before: always;
  break-before: page;
}

/* Evitar cortes internos */
.avoid-break,
.maps,
.tablePadre, .tablePadre tr, .tablePadre td, .tablePadre th,
.comparision, .comparision-item,
.print-page, .pageGrid, .cardphoto {
  break-inside: avoid;
  page-break-inside: avoid;
}

/* Primera página */
.header-block{ margin-bottom:8px; }
.titleLabel{ font-size:16px; }
.informacionContratoReporte{ font-size:12px; }
.informacionContratoReporte .maps{ margin-top:28px; }
.informacionContratoReporte .row{ display:flex; flex-wrap:wrap; margin-bottom:10px; }
.informacionContratoReporte .col{ flex:1; min-width:150px; padding:5px; box-sizing:border-box; }
.informacionContratoReporte .col img{ width:100%; height:auto; display:block; }

/* Tabla */
.tablePadre{ border-collapse:collapse; width:100%; margin-top:6px; }
.tablePadre th,.tablePadre td{ border:1px solid #000; padding:2px; text-align:left; vertical-align:top; }

/* Páginas de fotos 3x3 */
.print-page{
  --page-w:794px; --pad-x:53px; --pad-y:76px; --gap:10px; --cols:3; --rows:3;
  --col-w: calc((var(--page-w) - (2*var(--pad-x)) - ((var(--cols) - 1) * var(--gap))) / var(--cols));
  --grid-h: calc(1123px - (2*var(--pad-y)));
  width:var(--page-w); height:1123px; padding:var(--pad-y) var(--pad-x);
  background:#fff; overflow:hidden; display:block;
}
@media print { .print-page:not(:last-child){ page-break-after:always; break-after:page; } }

.pageGrid{
  display:grid; grid-template-columns:repeat(3,var(--col-w)); grid-template-rows:repeat(3,1fr);
  column-gap:var(--gap); row-gap:var(--gap); margin-top:0; height:var(--grid-h); justify-content:space-between;
}

/* Card foto */
.cardphoto{
  width:var(--col-w);
  height:calc((var(--grid-h) - ((var(--rows)-1)*var(--gap))) / var(--rows));
  background-color:#a0b5bf;
  padding:0; margin:0; box-sizing:border-box;
  border:1px solid #000; border-radius:4px;
  display:flex; flex-direction:column; justify-content:flex-start;
  overflow:hidden; position:relative;
}
.cardphoto img{ width:100%; height:60%; object-fit:cover; border:1px solid #000; border-radius:2px; background:#fff; flex-shrink:0; }
.cardphoto .card-body{ padding:0.5rem; font-size:11px; line-height:1.45; color:#000; }
.cardphoto .card-text{ font-size:10px; color:#000; margin:0; }

/* Comparision */
.comparision{ display:flex; flex-direction:column; }
.comparision h3{ margin:0 0 16px 0; }
.comparision .comparisionImgs{ display:flex; flex-wrap:wrap; gap:12px; justify-content:space-between; }
.comparision-item{ margin-bottom:20px; }
.cardphotoComparative{ position:relative; display:inline-block; width:calc(50% - 8px); }
.cardphotoComparative img{ display:block; width:100%; height:260px; object-fit:cover; border-radius:4px; border:1px solid #000; }

/* Bounding boxes */
.bb-main{
  position:absolute; border:2px solid rgba(0,102,255,0.95);
  box-shadow:0 0 0 1px rgba(0,102,255,0.35) inset; z-index:2; pointer-events:none;
}
.bb-rel{
  position:absolute; border:2px solid rgba(220,0,0,0.95);
  box-shadow:0 0 0 1px rgba(220,0,0,0.35) inset; z-index:3; pointer-events:none;
}
.bb-label{
  position:absolute; top:-16px; left:0; transform:translateY(-2px);
  background:rgba(0,0,0,0.75); color:#fff; font-size:10px; line-height:1;
  padding:2px 4px; border-radius:3px; white-space:nowrap;
}

/* Pulso por score (opcional) */
@keyframes pulse{ 0%{opacity:.35;transform:scale(1);} 50%{opacity:0;transform:scale(1.03);} 100%{opacity:0;transform:scale(1.05);} }
.cardphotoComparative.border-green::before,.cardphotoComparative.border-green::after,
.cardphotoComparative.border-yellow::before,.cardphotoComparative.border-yellow::after,
.cardphotoComparative.border-red::before,.cardphotoComparative.border-red::after{
  content:''; position:absolute; top:1px; left:1px; right:1px; bottom:1px;
  border:2px solid; border-radius:4px; opacity:0; animation:pulse 2s infinite; pointer-events:none;
}
.cardphotoComparative.border-green::before,.cardphotoComparative.border-green::after{ border-color:green; }
.cardphotoComparative.border-yellow::before,.cardphotoComparative.border-yellow::after{ border-color:gold; }
.cardphotoComparative.border-red::before,.cardphotoComparative.border-red::after{ border-color:red; }
.cardphotoComparative::before{ animation-delay:0s; } .cardphotoComparative::after{ animation-delay:1s; }

/* Utilidades */
.row4-wrapper{ display:flex; flex-wrap:wrap; margin-bottom:10px; }
.row4-col{ flex:1; min-width:150px; padding:5px; box-sizing:border-box; }
img,canvas{ max-width:100%; display:block; }
.bg-white{ background:#fff !important; }
`;

/* ===================== Helpers ===================== */
function row4(labelLeft, valueLeft, labelRight, valueRight) {
    return React.createElement("div", { className: "row4-wrapper" }, [
        React.createElement("div", { key: "l1", className: "row4-col" }, React.createElement("b", null, labelLeft)),
        React.createElement("div", { key: "l2", className: "row4-col" }, valueLeft || ""),
        React.createElement("div", { key: "r1", className: "row4-col" }, labelRight ? React.createElement("b", null, labelRight) : ""),
        React.createElement("div", { key: "r2", className: "row4-col" }, valueRight || "")
    ]);
}

function buildProxied(url, proxyBase) {
    if (!proxyBase || !url || url.startsWith("data:")) return url;
    try {
        if (url.startsWith(proxyBase)) return url;
        return proxyBase + encodeURIComponent(url);
    } catch {
        return url;
    }
}

function SafeImg({ src, alt = "", style = {}, className, proxyBase, onLoad }) {
    const attrs = {
        key: "img",
        src,
        alt,
        style,
        className,
        onError: (e) => {
            const tried = e.currentTarget.getAttribute("data-tried-proxy") === "1";
            if (!tried && proxyBase && src && !src.startsWith("data:")) {
                e.currentTarget.setAttribute("data-tried-proxy", "1");
                e.currentTarget.src = buildProxied(src, proxyBase);
            }
        },
        loading: "eager",
        decoding: "sync",
        onLoad
    };
    return React.createElement("img", attrs);
}

function chunkByNine(arr = []) {
    const out = [];
    for (let i = 0; i < arr.length; i += 9) out.push(arr.slice(i, i + 9));
    return out;
}

function normalizeBB(bb) {
    if (!bb) return null;
    const norm = (v) => typeof v === "number" && v >= 0 && v <= 1;
    const has = (k) => typeof bb[k] === "number";
    if (norm(bb.top) && norm(bb.left)) {
        if (has("width") && has("height")) return { top: bb.top, left: bb.left, width: bb.width, height: bb.height };
        if (has("right") && has("bottom")) return { top: bb.top, left: bb.left, width: bb.right - bb.left, height: bb.bottom - bb.top };
    }
    return null;
}

function renderBBOverImage(ev) {
    const overlays = [];
    const m = normalizeBB(ev?.bounding_box);
    if (m) {
        overlays.push(
            React.createElement("div", {
                key: "bbm",
                className: "bb-main",
                style: {
                    top: (m.top * 100) + "%", left: (m.left * 100) + "%", width: (m.width * 100) + "%", height: (m.height * 100) + "%"
                }
            })
        );
    }
    if (Array.isArray(ev?.related_objects)) {
        ev.related_objects.forEach((obj, i) => {
            const bb = normalizeBB(obj?.boundingBox);
            if (!bb) return;
            overlays.push(
                React.createElement("div", {
                    key: "bbr-" + i,
                    className: "bb-rel",
                    style: {
                        top: (bb.top * 100) + "%", left: (bb.left * 100) + "%", width: (bb.width * 100) + "%", height: (bb.height * 100) + "%"
                    }
                }, [
                    React.createElement("span", { key: "lbl", className: "bb-label" }, obj?.tagName || obj?.type || "obj")
                ])
            );
        });
    }
    return overlays;
}

function linesFromResults(results) {
    if (!results || typeof results !== "object") return [];
    const lines = [];
    const score = results?.scores?.status;
    if (typeof results.status === "string") {
        const icon = score === 1 ? "✅" : score === 2 ? "⚠️" : score >= 3 ? "❌" : "•";
        lines.push({ icon, text: results.status });
    }
    const pairs = [
        ["container_closure", "alerts?.container_closure"],
        ["physical_condition", "alerts?.physical_condition"],
        ["seals", "alerts?.seals"],
        ["security_labels", "alerts?.security_labels"],
        ["electronic_seal", "alerts?.electronic_seal"]
    ];
    for (const [k, flagPath] of pairs) {
        const msg = results?.[k];
        const flag = flagPath.split(".").reduce((acc, p) => (acc ? acc[p] : undefined), results);
        if (typeof msg === "string") lines.push({ icon: flag ? "⚠️" : "✅", text: msg });
    }
    if (Array.isArray(results?.notes)) results.notes.forEach((t) => lines.push({ icon: "•", text: String(t) }));
    return lines;
}

/* ===================== Componente ===================== */
export default function ReporteStaticHTML({ data, imgProxy }) {
    if (!data) return null;

    const contrato = data.contrato || {};
    const fotos = data.fotos || [];
    const reportes = data.reportes || [];
    const comparision = data.comparision || [];
    const mapas = data.mapas || {};
    const proxyBase = imgProxy;

    const fotoPages = chunkByNine(fotos);

    return React.createElement("div", { id: "reporte-static-root" }, [
        React.createElement("style", { key: "style-block" }, customStyles),

        /* ====== PÁGINA 1: cabecera + mapas ====== */
        React.createElement("div", { key: "page-1", className: "avoid-break no-flex-print" }, [
            React.createElement("div", { key: "header", className: "header-block" }, [
                React.createElement(
                    "div",
                    { key: "logo-row-1", className: "row py-1" },
                    React.createElement(SafeImg, {
                        src: "https://static.wixstatic.com/media/9a4347_a8dbd9ccfecd4eb2b4239eadc7369c73~mv2.png/v1/fill/w_383,h_93,al_c,lg_1,q_85,enc_auto/logo-logiseguridad2-PNG.png",
                        alt: "Logo",
                        style: { width: "300px" },
                        proxyBase
                    })
                ),
                React.createElement("div", { key: "title-row", className: "title-row" }, "REPORTE DE SERVICIO EN TRANSITO"),
                React.createElement("div", { key: "info-contrato", className: "informacionContratoReporte no-flex-print" }, [
                    row4("CLIENTE:", contrato.NombreEmpresa, "COD. SERVICIO:", contrato.ContractID),
                    row4("RUTA:", contrato.DescripcionRuta, "DISPOSITIVO:", contrato.FKLokDeviceID),
                    row4("CONDUCTOR:", contrato.NombreConductor, "CELULAR:", contrato.MovilConductor),
                    row4("PLACA CABEZOTE:", contrato.PlacaTruck, "PLACA REMOLQUE:", contrato.PlacaTrailer),
                    row4("TRANSPORTADOR:", contrato.NombreTranspo, "INICIO SERVICIO:", contrato.fecha),
                    row4("CONTENEDOR N°:", contrato.ContainerNum, "FINAL SERVICIO:", contrato.fechafin),
                    row4("REFERENCIA:", contrato.Ref, "", ""),
                    React.createElement("div", { key: "maps-row", className: "row maps no-flex-print", style: { overflow: "visible" } }, [
                        React.createElement("div", { key: "map-ultimo", className: "col" }, [
                            React.createElement("b", { key: "lbl-u" }, "Último Punto"),
                            React.createElement("br"),
                            mapas.ultimoPuntoUrl
                                ? React.createElement(SafeImg, {
                                    key: "img-u",
                                    src: mapas.ultimoPuntoUrl,
                                    alt: "Último Punto",
                                    style: { width: "100%", height: "auto", maxHeight: "250px", objectFit: "cover", border: "1px solid #000", background: "#fff" },
                                    proxyBase
                                })
                                : React.createElement("div", { key: "nomap-u", style: { fontSize: "10px", color: "#555" } }, "No disponible")
                        ]),
                        React.createElement("div", { key: "map-recorrido", className: "col" }, [
                            React.createElement("b", { key: "lbl-r" }, "Recorrido"),
                            React.createElement("br"),
                            mapas.recorridoUrl
                                ? React.createElement(SafeImg, {
                                    key: "img-r",
                                    src: mapas.recorridoUrl,
                                    alt: "Recorrido",
                                    style: { width: "100%", height: "auto", maxHeight: "250px", objectFit: "cover", border: "1px solid #000", background: "#fff" },
                                    proxyBase
                                })
                                : React.createElement("div", { key: "nomap-r", style: { fontSize: "10px", color: "#555" } }, "No disponible")
                        ])
                    ])
                ])
            ])
        ]),

        /* ===== SALTO OBLIGATORIO DESPUÉS DE LOS MAPAS ===== */
        React.createElement("div", {
            key: "pb-after-maps-wrap",
            className: "no-flex-print",
        }, React.createElement("div", {
            key: "pb-after-maps",
            className: "force-break html2pdf__page-break",
            style: {
                minHeight: "2mm",
                pageBreakAfter: "always",
                breakAfter: "page",
                visibility: "hidden",
                overflow: "visible"
            }
        })),

        /* ====== TABLA (si existe) ====== */
        ...(reportes.length > 0 ? [
            React.createElement("div", { key: "wrap-tabla", className: "keep-together no-flex-print" }, [
                React.createElement("table", { key: "tabla-trafico", className: "tablePadre" }, [
                    React.createElement("thead", { key: "thead" },
                        React.createElement("tr", null,
                            ["Fecha/Hora", "Acción", "Estado", "Ubicación", "Observaciones", "Usuario"].map((c) =>
                                React.createElement("th", { key: c }, c)
                            )
                        )
                    ),
                    React.createElement("tbody", { key: "tbody" },
                        reportes.map((r, idx) =>
                            React.createElement("tr", { key: idx }, [
                                React.createElement("td", { key: "f" }, formattedGlobalDate(r.XTime)),
                                React.createElement("td", { key: "a" }, r.TipoAccion || ""),
                                React.createElement("td", { key: "e" }, r.TipoReporte || ""),
                                React.createElement("td", { key: "u" }, r.Ubicacion || ""),
                                React.createElement("td", { key: "o" }, r.Nota || ""),
                                React.createElement("td", { key: "x" }, r.XUser || "")
                            ])
                        )
                    )
                ])
            ]),
            /* ===== SALTO OBLIGATORIO DESPUÉS DE LA TABLA ===== */
            React.createElement("div", {
                key: "pb-after-table-wrap",
                className: "no-flex-print",
            }, React.createElement("div", {
                key: "pb-after-table",
                className: "force-break html2pdf__page-break",
                style: {
                    minHeight: "2mm",
                    pageBreakAfter: "always",
                    breakAfter: "page",
                    visibility: "hidden",
                    overflow: "visible"
                }
            }))
        ] : []),

        /* ====== ANÁLISIS DE SEGURIDAD ====== */
        ...(Array.isArray(comparision) && comparision.length > 0 ? [
            React.createElement("div", {
                key: "cmp-start",
                className: "page-start",
                style: { pageBreakBefore: "always", breakBefore: "page" }
            }),
            React.createElement("div", { key: "cmp", className: "comparision avoid-break" }, [
                React.createElement("h3", { key: "h" }, "Análisis de seguridad"),
                ...comparision.slice().reverse().map((item, idxCmp) =>
                    React.createElement("div", { key: "cmp-" + idxCmp, className: "comparision-item" }, [
                        React.createElement("div", { key: "imgs-" + idxCmp, className: "comparisionImgs" },
                            (item.enrichedEvents || []).map((ev, i) => {
                                const src = ev.imageBase64 || ev.imageUrl || "";
                                if (!src) return null;
                                const cls = `cardphotoComparative border-${item.scoreColor || "transparent"}`;
                                return React.createElement("div", { key: "ev-" + i, className: cls, style: { position: "relative" } }, [
                                    React.createElement("div", { key: "wrap", style: { position: "relative" } }, [
                                        React.createElement(SafeImg, {
                                            key: "img",
                                            src,
                                            alt: "comparativa",
                                            proxyBase,
                                            style: { width: "100%", height: "260px", objectFit: "cover", border: "1px solid #000", background: "#fff", borderRadius: "4px" }
                                        }),
                                        React.createElement("div", { key: "bbwrap", style: { position: "absolute", inset: 0 } }, renderBBOverImage(ev))
                                    ]),
                                    (ev.meta && (ev.meta.Evento || ev.meta.Hora))
                                        ? React.createElement("div", { key: "body", className: "card-body infoAditionalBody" }, [
                                            React.createElement("p", { key: "p1", className: "card-text" }, `ID: ${item.assetId ?? "-"}`),
                                            React.createElement("p", { key: "p2", className: "card-text" }, `Evento: ${ev.meta.Evento ?? "-"}`),
                                            React.createElement("p", { key: "p3", className: "card-text" }, `Fecha/Hora: ${ev.meta.Hora ?? "-"}`)
                                        ])
                                        : null
                                ]);
                            })
                        ),
                        React.createElement("div", { key: "res-" + idxCmp, className: "comparisionResults" }, [
                            React.createElement("h5", { key: "t", className: "titleLabel" }, `${item.assetType || "Asset"} - ${item.assetId || "-"}`),
                            ...linesFromResults(item.results).map((ln, j) =>
                                React.createElement("div", { key: "ln-" + j }, [ln.icon, " ", React.createElement("span", { key: "txt" }, ln.text)])
                            )
                        ])
                    ])
                )
            ])
        ] : []),

        /* ====== FOTOS 3×3 (SIN HEADER) ====== */
        ...(fotoPages.length > 0
            ? fotoPages.map((page, pIdx) => (
                React.createElement(React.Fragment, { key: "fp-" + pIdx }, [
                    React.createElement("div", {
                        key: "fotos-start-" + pIdx,
                        className: "page-start",
                        style: { pageBreakBefore: "always", breakBefore: "page" }
                    }),
                    React.createElement("div", { key: "print-p-" + pIdx, className: "print-page" }, [
                        React.createElement("div", { key: "pageGrid-" + pIdx, className: "pageGrid" },
                            page.map((photo, idx) => {
                                const src = (photo && photo.SourceBase64) || (photo && photo.Source) || "";
                                return React.createElement("div", { key: idx, className: "cardphoto avoid-break" }, [
                                    React.createElement(SafeImg, {
                                        key: "img",
                                        src,
                                        alt: (photo && photo.Evento) || "foto",
                                        style: { width: "100%", height: "60%", objectFit: "cover", border: "1px solid #000", background: "#fff" },
                                        proxyBase
                                    }),
                                    React.createElement("div", { key: "body", className: "card-body" },
                                        React.createElement("p", { className: "card-text" }, [
                                            "Evento: ", photo?.Evento, React.createElement("br", { key: "br1" }),
                                            "Latitud: ", photo?.Latitud, React.createElement("br", { key: "br2" }),
                                            "Longitud: ", photo?.Longitud, React.createElement("br", { key: "br3" }),
                                            "Geocerca: ", photo?.Geo, React.createElement("br", { key: "br4" }),
                                            photo?.Hora
                                        ])
                                    )
                                ]);
                            })
                        )
                    ])
                ])
            ))
            : [])
    ]);
}
